import React from 'react';
import { Link } from '../Link.jsx';
import { getOrgSlug } from '../../lib/utils.js';
import { replaceRoute } from '../../lib/router.js';
import { isEmpty, pickBy } from 'lodash';

export const SurveyLink = ({
  initiative,
  initiativeParticipationId,
  status,
  sentiment,
  ...props
}) => (
  <Link
    {...SurveyLink.getLinkProps(
      initiative,
      initiativeParticipationId,
      status,
      sentiment
    )}
    {...props}
  />
);

SurveyLink.getLinkProps = (
  initiative,
  initiativeParticipationId,
  status,
  sentiment
) => ({
  route: 'change-insights/studio/show',
  params: pickBy({
    initiativeId: initiative.id,
    initiativeType: initiative.type,
    participant: initiativeParticipationId,
    status,
    overview: sentiment,
  }),
});

export const ChangeInsightsStudioLink = ({
  initiative,
  initiativeParticipationId,
  status,
  sentiment,
  ...props
}) => (
  <Link
    {...ChangeInsightsStudioLink.getLinkProps(
      initiative,
      initiativeParticipationId,
      status,
      sentiment
    )}
    {...props}
  />
);

ChangeInsightsStudioLink.getLinkProps = (
  initiative,
  initiativeParticipationId,
  status,
  sentiment
) => ({
  route: 'change-insights/studio/show',
  params: pickBy({
    initiativeId: initiative.id,
    initiativeType: initiative.type,
    participant: initiativeParticipationId,
    status,
    overview: sentiment,
  }),
});

export const ChangeInsightsAnalysisLink = ({
  initiative,
  initiativeParticipationId,
  status,
  sentiment,
  ...props
}) => (
  <Link
    {...ChangeInsightsAnalysisLink.getLinkProps(
      initiative,
      initiativeParticipationId,
      status,
      sentiment
    )}
    {...props}
  />
);

ChangeInsightsAnalysisLink.getLinkProps = (
  initiative,
  initiativeParticipationId,
  status,
  sentiment
) => ({
  route: 'change-insights/analysis/show',
  params: pickBy({
    initiativeId: initiative.id,
    initiativeType: initiative.type,
    participant: initiativeParticipationId,
    status,
    overview: sentiment,
    slug: getOrgSlug(),
  }),
});

export const TemplateViewLink = ({ templateId, ...props }) => (
  <Link
    route="change-insights/studio/preview"
    params={{ templateId, slug: getOrgSlug() }}
    {...props}
  />
);

export const navigateToChangeInsightDetails = (
  query,
  initiativeId,
  initiativeType
) => {
  if (!initiativeId || !initiativeType) {
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    initiativeType = initiativeType || pathParts[1];
    initiativeId = initiativeId || parseInt(pathParts[2], 10);
  }

  const existingParams = window.location.pathname.includes('/change-insights')
    ? Object.fromEntries(new URLSearchParams(window.location.search))
    : {};

  const parseFilterParam = (value) => {
    if (typeof value !== 'string') return value;
    return value.split('/').map((v) => {
      if (v === 'none') return v;
      const num = Number(v);
      return isNaN(num) ? v : num;
    });
  };

  const parsedExisting = {};
  for (const [key, value] of Object.entries(existingParams)) {
    if (
      [
        'employeeIds',
        'groupIds',
        'organizationStakeholderIds',
        'statuses',
      ].includes(key)
    ) {
      parsedExisting[key] = parseFilterParam(value);
    } else {
      parsedExisting[key] = value;
    }
  }

  const params = pickBy(
    {
      initiativeType,
      initiativeId,
      slug: getOrgSlug(),
      ...parsedExisting,
      ...query,
    },
    (value) => {
      // Keep numbers (including 0), booleans (including false), and non-empty values
      if (typeof value === 'number' || typeof value === 'boolean') return true;
      return !isEmpty(value);
    }
  );
  replaceRoute('change-insights/studio/show', params);
};
